'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _login = require('./login.component');

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginModule = _angular2.default.module('app.login', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('login', {
    url: '/login',
    template: '<login></login>'
  });
}).component('login', _login2.default);

exports.default = loginModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/login/login.js
 **/